import { ClientsFormModel } from 'lemunzo-api';
import {
    AddedElementModel,
    ElementType,
} from '../models/clientsform/added-element-model';
import {
    InputElementModel,
    InputHTMLTypes,
} from '../models/clientsform/input-element-model';
import { TextareaElementModel } from '../models/clientsform/textarea-element.model';
import { ConstantsService } from '../services/constants.service';
import { BodyCategoryModel } from '../models/clientsform/body-category-model';

/**
 * Performs a Clients form initialization after being loaded from the server. Transforms specific types (such as dates)
 * from their auto-deserialized form to specific types (such as Date objects). Must be run explicitly after the form
 * is loaded since the auto-generated service cannot have this auto-appended.
 *
 * @param form the form that should have its element values initialized
 * @returns the initialized form
 */
export function initializeClientsForm(
    form: ClientsFormModel
): ClientsFormModel {
    // Convert date strings to Date objects, valid only for body elements
    const bodyInputs = form.body.map((category: BodyCategoryModel) => ({
        ...category,
        elements: category.elements.map((element: AddedElementModel) => {
            let value = element;
            // Dates are only possible for inputs
            if (value.type === ElementType.Input) {
                let inputModel = value as InputElementModel;
                if (inputModel.typeInHTML === InputHTMLTypes.DATE) {
                    if (inputModel.min) {
                        inputModel.min = new Date(inputModel.min?.toString());
                    }
                    if (inputModel.max) {
                        inputModel.max = new Date(inputModel.max?.toString());
                    }
                }
            }

            if (value.type === ElementType.Textarea) {
                return migrateTextareaRows(value as TextareaElementModel);
            }
            return value;
        }),
    }));
    return {
        ...form,
        body: bodyInputs,
    };
}

/**
 * Migrates legacy minRows/maxRows to the unified rows property.
 */
function migrateTextareaRows(
    textarea: TextareaElementModel
): TextareaElementModel {
    textarea.rows ??=
        (textarea as any).minRows ??
        (textarea as any).maxRows ??
        ConstantsService.TEXTAREA_ROWS_DEFAULT;
    return textarea;
}
